<template>
  <v-container fluid grid-list-md>
    <v-layout column wrap>
      <v-flex xs12>
        <filters-bar
          title="Contactabilidad"
          title-class="headline font-weight-thin"
          :has-date-type="false"
          :has-company-load="true"
          dateBoxSize="md3"
          :filters="filters"
          @search="changeFilters"
        >
          <template slot="content">
            <v-flex md2>
              <v-btn block class="h-100 ma-0 w-100" @click="showModal = true">
                <v-icon small>fas fa-download</v-icon>
              </v-btn>
            </v-flex>
          </template>
        </filters-bar>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text class="pt-2 pb-2 pr-0">
            <v-layout row wrap>
              <v-flex md6 style="position: relative;">
                <transition name="fade-effect" mode="out-in">
                  <!-- 3 -->
                  <template v-if="isSearching || step < 1">
                    <skeleton-box class="pa-3 ml-3 mt-3 mb-2" :flat="true">
                      <avatar-skeleton size="275px"></avatar-skeleton>
                    </skeleton-box>
                  </template>
                  <template v-else>
                    <template v-if="data[1].value > 0 || data[0].value > 0">
                      <pie
                        :step="step"
                        @update-step="$emit('update-step', $event)"
                        key="pieContact"
                        :data="data"
                      />
                    </template>
                    <template v-else>
                      <v-layout class="h-100 align-center text-xs-center">
                        <v-flex>
                          <span>No hay información</span>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                </transition>
                <actual-button :filters="filters" :disabled="disabledActual"></actual-button>
              </v-flex>
              <v-flex md6>
                <channels @change="setChannels" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <download-modal
      :show="showModal"
      @change="showModal = $event"
      title="Seleccione el tipo de archivo a descargar"
      :items="downloadOptions"
      :filtered-select="true"
      :items-filter="fileOptions"
      label="Tipo de contactabilidad"
      @download="generateReport"
    >
      <div slot="filteredHeader">Cargue el archivo con el que va a filtrar</div>
      <div slot="filteredContent">
        <input type="file" ref="file" @change="handleFileUpload()" />
      </div>
    </download-modal>
  </v-container>
</template>
<script>
import moment from 'moment';
import FiltersBar from '@/components/global/FiltersBar';
import AvatarSkeleton from '@/components/global/skeletons/Avatar';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import DownloadModal from '../DownloadModal';
import ActualButton from '../ActualButton';
import Channels from './Channels';
import Pie from './Pie';

export default {
  props: {
    step: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AvatarSkeleton,
    DownloadModal,
    ActualButton,
    SkeletonBox,
    FiltersBar,
    Channels,
    Pie,
  },
  data() {
    return {
      filters: {
        date: moment().format('YYYY-MM'),
        total_load: 0,
        dateType: 'month',
        company_load: 0,
      },
      file: '',
      fileOptions: [
        {
          text: 'Reporte de contactabilidad general',
          value: 0,
        },
        {
          text: 'Reporte filtrado por archivo de cuentas',
          value: 1,
        },
      ],
      oldDate: moment().format('YYYY-MM'),
      showModal: false,
      isSearching: true,
      cancelToken: this.axios.CancelToken.source(),
      channels: [
        {
          text: 'Teléfono celular',
          conector: 'AND',
        },
      ],
      data: [
        {
          name: 'Con contacto',
          value: 0,
        },
        {
          name: 'Sin contacto',
          value: 0,
        },
      ],
      downloadOptions: [
        {
          text: 'Con contacto',
          value: 1,
        },
        {
          text: 'Sin contacto',
          value: 0,
        },
      ],
    };
  },
  computed: {
    disabledActual() {
      return this.filters.date !== moment().format('YYYY-MM');
    },
  },
  methods: {
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    generateReport(contacted, filtered) {
      let functionName = '';
      if (!filtered) {
        const obj = { ...this.filters };
        obj.last_company_load = obj.company_load;
        delete obj.company_load;
        if (this.filters.date === moment().format('YYYY-MM')) {
          functionName = 'customerReport';
        } else {
          functionName = 'contactability';
        }
        this.$store.commit(
          'SET_DOWNLOAD_CHANNEL',
          `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`,
        );
        this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
          route: 'reports',
          params: {
            filters: {
              ...obj,
              conditions: this.channels,
              contacted,
              filename: 'Contactabilidad de clientes',
            },
            functionName,
          },
        });
      } else {
        functionName = 'contactability_by_filter';
        const formData = new FormData();
        formData.append('file', this.file);

        this.axios.post('/reports/upload', formData).then((response) => {
          this.$store.commit(
            'SET_DOWNLOAD_CHANNEL',
            `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`,
          );
          this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
            route: 'reports',
            params: {
              filters: {
                filename: response.data,
              },
              functionName,
            },
          });
        });
      }
    },
    search() {
      const obj = { ...this.filters };
      obj.last_company_load = obj.company_load;
      delete obj.company_load;
      if (obj.date !== this.oldDate) {
        obj.last_company_load = 0;
      }
      this.isSearching = true;
      this.cancelRequest();
      this.axios
        .get('contactability/report', {
          cancelToken: this.cancelToken.token,
          params: {
            ...obj,
            conditions: this.channels,
          },
        })
        .then((res) => {
          this.oldDate = this.filters.date;
          this.filters.company_load = res.data.companyLoadId;
          this.data[0].value = Number(res.data.contacted.contacted);
          if (res.data.contacted.total > 0) {
            this.data[1].value =
              Number(res.data.contacted.total) - this.data[0].value;
          } else {
            this.data[1].value = 0;
          }
          this.isSearching = false;
        }).catch(() => {})
        .then(() => {
          if (this.data[1].value < 1 && this.data[0].value < 1) {
            this.$emit('update-step', 4);
          }
        });
    },
    changeFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
      this.search();
    },
    setChannels(channels) {
      this.channels = channels;
      this.search();
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
  watch: {
    'filters.total_load': {
      handler() {
        this.search();
      },
    },
    'filters.date': {
      handler(val) {
        if (val !== moment().format('YYYY-MM')) {
          this.filters.total_load = true;
        } else {
          this.filters.total_load = false;
        }
      },
    },
    step: {
      immediate: true,
      handler(value) {
        if (value === 3) {
          this.search();
        }
      },
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/panelV2/Contactability/Index.vue